import React from "react";
import { stripRTFTags } from "./utils";

export function SearchRecordTile({
  record,
  setSelectedRecord,
}: {
  record: any;
  setSelectedRecord: (record: any) => void;
}) {
  // console.log(record);
  return (
    <div className="searchRecordTile" key={record.recordId}>
      <div
        className="searchRecordTileMain"
        onClick={() => {
          setSelectedRecord(record);
        }}>
        {record.thumbnailUrl && (
          <div className="searchRecordTileThumbnail">
            <img
              src={record.thumbnailUrl
                .replace("resdb:///", "https://assets.resonite.com/")
                .split(".")
                .slice(0, -1)
                .join(".")}
              alt={stripRTFTags(
                `${record.name} by ${record.ownerName || record.ownerId}`
              )}
              title={stripRTFTags(
                `${record.name} by ${record.ownerName || record.ownerId}`
              )}></img>
          </div>
        )}
        <div className="searchRecordTileTitle">{stripRTFTags(record.name)}</div>
        <div
          className="searchRecordTileOwner"
          title={record.ownerId}
          onClick={
            // copy owner ID
            () => navigator.clipboard.writeText(record.ownerId)
          }>
          {record.ownerName || record.ownerId}
        </div>
      </div>
      {/* copy asset URI */}
      <div
        className="searchRecordTileCopyButton searchRecordTileCopyRecordButton"
        onClick={() =>
          navigator.clipboard.writeText(
            `resrec:///${record.ownerId}/${record.recordId}`
          )
        }>
        {}
        Copy record URI
      </div>
      {record.assetUri && (
        <div
          className="searchRecordTileCopyButton searchRecordTileCopyAssetButton"
          onClick={() => navigator.clipboard.writeText(record.assetUri)}>
          Copy asset URI
        </div>
      )}
    </div>
  );
}
